module.exports = __webpack_public_path__ + "static/5-e5cef240ee11972efb21695e0ec852a3.jpg";